<template>
  <div>
    <h2>{{ $t('title.restore-mobile-access') }}</h2>

    <data-form
      :entity="entity"
      :fields="fields"
      @submit="submit"
    />

  </div>
</template>

<script>
import findAll from 'service/findAll'
import { post } from 'providers/http'

export default {
  name: 'RestoreMobileAccess',
  data () {
    return {
      entity: {
        restoreMobileId: null
      }
    }
  },
  computed: {
    fields () {
      return {
        restoreMobileId: {
          type: 'select',
          options: this.mobiles
        }
      }
    }
  },
  methods: {
    async submit () {
      try {
        await post('api/v1/restore-mobile', {
          mobileId: this.$route.params.id,
          restoreMobileId: this.entity.restoreMobileId
        })

        this.showSuccess('restore-success')
        this.$router.back()
      }
      catch (err) {
        console.error(err)

        this.showError('failed-to-restore')
      }
    }
  },
  mixins: [
    findAll('mobiles', {
      filter (mobile) {
        return mobile.id !== this.$route.params.id
      },
      map: (mobile) => ({ value: mobile.id, label: mobile.contact_name })
    })
  ]
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// RestoreMobileAccess.vue?61cac098